import { render, staticRenderFns } from "./TerminalAdsFooter.vue?vue&type=template&id=5ea007b1&scoped=true"
import script from "./TerminalAdsFooter.vue?vue&type=script&lang=js"
export * from "./TerminalAdsFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea007b1",
  null
  
)

export default component.exports